import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import styles from "./styles.module.scss";
import { chartData } from "./mock";

export const ChartPricing = () => {
  return (
    <div
      className={styles.chartWrapper}
      style={{ width: "100%", height: "320px" }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <CartesianGrid
            stroke="#333"
            strokeDasharray="0"
            horizontal={true}
            vertical={true}
          />
          <XAxis
            dataKey="name"
            tick={{ fill: "#666", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis hide={true} />
          <Line
            type="monotone"
            dataKey="blue"
            stroke="#5295E0"
            strokeWidth={2}
            dot={false}
          />
          <Line
            type="monotone"
            dataKey="red"
            stroke="#FF5C5C"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
